"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M14.6233 3c-.41 0-.77.12-1.05.4-.27.29-.39.67-.39 1.1 0 .29.05.56.18.79.13.23.3.41.52.53.22.12.47.18.72.18.41 0 .77-.12 1.04-.41.28-.29.39-.67.39-1.1 0-.29-.05-.55-.18-.79-.12-.22-.29-.4-.51-.52-.22-.12-.46-.18-.72-.18zm2.16 4.78c-.1-.45-.5-.78-.97-.78h-2.4a.9938.9938 0 0 0-.8543.4878L9.6854 11.667 6.88 11.6667c-.3 0-.5734.06-.8.1933-.2267.1333-.4.3133-.52.5467-.12.2266-.1734.48-.1734.76v4.5H6.72V21h1.3334v-3.3333h1.3333c0-1.5563.0167-3.1135-.0007-4.6697h.9989l1.3263-1.9288L10.6133 16h3v5h2v-5h3l-1.83-8.22z"
  }), _react.default.createElement("path", {
    d: "M7.384 11.0003c.6618 0 1.1984-.473 1.1984-1.2658 0-.8126-.5366-1.2658-1.1984-1.2658-.662 0-1.1985.4613-1.1985 1.2658 0 .7955.5366 1.2658 1.1985 1.2658z"
  })];
};

exports.default = _default;